import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from './../../../../shared/services/profile.service';
import { StudentsService } from 'src/app/shared/services/students.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlStudentSchoolFieldTrip, StudentFieldTripDataService } from '../../student-list-widget/models/SchoolFiledTripModel';

@Component({
  selector: 'app-student-fieldtrip-list',
  templateUrl: './student-fieldtrip-list.component.html',
  styleUrls: ['./student-fieldtrip-list.component.scss']
})
export class StudentFieldtripListComponent implements OnInit {

  fieldTripList: MdlStudentSchoolFieldTrip[] = [];
  studentId: string = "";
  btnText: string = "Submit Form";
  fieldTripConsent: string = '';
  consentTrip: boolean = false;
  innerLoadingMsg: string = "Getting Trips, Please Wait...";
  isTripsAvailable = true;
  parentName:string="";
  isLoading: boolean = true;

  constructor(private toastr: ToastrService,
    private studentService: StudentsService,
    private profileService: ProfileService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private dataService: StudentFieldTripDataService) { }

  ngOnInit(): void {
    const currentUser = this.profileService.identity;

    if (currentUser.userType.toLowerCase() == "student") {
      this.studentId = currentUser.userIdRole;
    }
    else if (currentUser.userType.toLowerCase() == "parent") {      
      this.parentName=currentUser.displayName;
      this.activeRoute.parent.params.subscribe((data) => {
       
        this.studentId = data.studentId;
      });
    }
    if (this.studentId) {
      this.getSchoolFieldTripDetailsByStudentID();
    }
  }
getSchoolFieldTripDetailsByStudentID() {

  const timestamp = Date.now();
  console.log("Timestamp: " +timestamp);

  const localTime = new Date().toLocaleString();
  console.log("LocalTime: " + localTime);

  const isoString = new Date().toISOString();
  console.log("isoString: " +isoString);

  this.innerLoadingMsg = "Getting Trips, Please Wait...";
  this.isLoading = true;

  this.studentService.getSchoolFieldTripDetails(this.studentId).subscribe(
    (tripList) => {
      this.fieldTripList = tripList?.mdlStudentSchoolFieldTrip || [];
      this.isLoading = false;

      if (!tripList?.isAnyTripAvailable || this.fieldTripList.length === 0) {
        this.innerLoadingMsg = "No school trips found.";
        this.isTripsAvailable = false;
      } else {
        this.isTripsAvailable = true;
      }
    },
    (error) => {
      this.isLoading = false;
      this.innerLoadingMsg = "Error loading trips.";
      this.isTripsAvailable = false;
    }
  );
}

  submitForm(event: Event, seletedModel: MdlStudentSchoolFieldTrip) {
    if (seletedModel.consentTrip === null) {
      this.toastr.warning("Choose consent trip option is required.", 'warning');
      event.preventDefault();
      event.stopPropagation();
    }
    else {
      seletedModel.acknowlegedBY="";
      seletedModel.consentTrip=this.consentTrip;
      this.dataService.sendModel(seletedModel);
      this.router.navigate(['/parent/students/' + this.studentId + '/fieldtripform']);
    }
  }

  onFieldTripConsentChange(value: string, trip: any) {
    trip.isShowingFormActions = true;
    if (value === "Yes") {
      this.consentTrip = true;
    }
    else {
      this.consentTrip = false;
    }
    trip.consentTrip = this.consentTrip;    
  }

  sendResponse($event: any) {
    const todayDate = this.getTodayDate();
    let requestForm = {
      consentTrip: this.consentTrip,
      acknowlegedBY: this.parentName,
      acknowlegedOn: todayDate,
    }

    this.studentService.submitScholFieldTripForm(this.studentId,
      $event.tripRefNo, requestForm).subscribe(       
        (result) => {
          this.getSchoolFieldTripDetailsByStudentID();
          if (typeof (result.error) !== 'undefined' && typeof (result.status) !== 'undefined') {
            // this.isRequestProcessing = false;
            this.toastr.error("Form Submission Failed.", "Error");
          }
          else {
            //this.isRequestProcessing = false;
            this.toastr.success("Form has been Submitted Successfully.", "Success");           
          }
        },
        (error) => {
          // this.isRequestProcessing = false;
          this.toastr.error("Form has been Submitted Successfully.", "Error");
        }
      );
  }

  getTodayDate(): string {
    const date = new Date();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  }
}
